import { Pipe, PipeTransform } from '@angular/core';
import { Converter } from '@app/shared/utils/converter';

@Pipe({
  standalone: true,
  name: 'tiToKendoDateFormat',
})
export class ToKendoDateFormatPipe implements PipeTransform {
  transform(date: string): string {
    return Converter.DateAndTime.toKendoDateFormat(date);
  }
}
